// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_54-2";
export var blackBorderOnHover = "_54-7";
export var cell = "_54-6";
export var cellContainer = "_54-3";
export var checked = "_54-8";
export var disabled = "_54-5";
export var featuredIconCellContainer = "_54-9";
export var featuredIconTextContainer = "_54-b";
export var featuredIconWrapper = "_54-a";
export var noBorder = "_54-c";
export var orangeSelectedRow = "_bo-3";
export var overflowableText = "_54-0";
export var overflowableTextContainer = "_54-1";
export var row = "_56-0";
export var rowCheckboxCell = "_54-4";
export var selectableTable = "_bo-2";